<template>
  <section class="group">
    <template v-if="hasLink">
      <NuxtLink
        :to="link?.href"
        class="max-w-full h-auto m-0 p-0 group-hover:brightness-80 transition-all duration-300 ease-in-out"
        :class="hasContent ? 'mb-4' : ''"
        :external="link?.external"
        :target="link?.external ? '_blank' : ''"
      >
        <slot name="image" />
        <p
          v-if="props.caption"
          class="text-caption text-surface-500"
          :class="[
            textAlign === 'right' ? 'lg:text-right' : 'lg:text-left',
            props.description ? 'mb-4' : 'mt-2',
          ]"
        >
          <DrupalMarkup :content="props.caption" />
        </p>

      </NuxtLink>
    </template>

    <template
      v-else
      class="max-w-full h-auto"
      :class="hasContent ? 'mb-4' : ''"
    >
      <div class="max-w-full h-auto" :class="hasContent ? 'mb-4' : ''">
        <slot name="image" />
      </div>
      <p
        v-if="props.caption"
        class="text-caption text-surface-500"
        :class="[
          textAlign === 'right' ? 'lg:text-right' : 'lg:text-left',
          props.description ? 'mb-4' : 'mt-2',
        ]"
      >
        <DrupalMarkup :content="props.caption" />
      </p>
    </template>
  </section>
</template>

<script setup lang="ts">
import type { Link, ResponsiveImage } from '~/types';

const props = withDefaults(
  defineProps<{
    caption?: string;
    description?: string | string[] | null;
    image?: ResponsiveImage;
    link?: Link;
    textAlign?: 'left' | 'right';
    title?: string;
    fetchPriority?: 'auto' | 'high' | 'low';
  }>(),
  {
    textAlign: 'left',
    fetchPriority: 'auto',
  }
);

const hasLink = computed(() => props.link?.href && props.link?.href.length > 1);
const hasContent = computed(() => {
  return Boolean(
    props.title?.length || props.caption?.length || props.description?.length
  );
});
</script>
